import type { CustomerCalendar } from '@/types/generated'
import { ref, watch, type Ref } from 'vue'

export type CalendarSettingsEntryKind = 'termin' | 'frist' | 'wiedervorlage'
export type CalendarKindChecks = Record<string, Record<CalendarSettingsEntryKind, boolean>>

const defaultKindChecks = (): Record<CalendarSettingsEntryKind, boolean> => ({
  termin: true,
  frist: true,
  wiedervorlage: true
})

export function useCalendarKindChecks(calendars: Ref<CustomerCalendar[]>) {
  const calendarKindChecks = ref<CalendarKindChecks>({})

  watch(
    calendars,
    (nextCalendars) => {
      const nextChecks: CalendarKindChecks = {}

      for (const calendar of nextCalendars) {
        if (!calendar.uuid) {
          continue
        }

        nextChecks[calendar.uuid] = {
          termin: calendarKindChecks.value[calendar.uuid]?.termin ?? true,
          frist: calendarKindChecks.value[calendar.uuid]?.frist ?? true,
          wiedervorlage: calendarKindChecks.value[calendar.uuid]?.wiedervorlage ?? true
        }
      }

      calendarKindChecks.value = nextChecks
    },
    { immediate: true }
  )

  const setAccountKindSync = ({
    calendarUuids,
    kind,
    checked
  }: {
    calendarUuids: string[]
    kind: CalendarSettingsEntryKind
    checked: boolean
  }): void => {
    const nextChecks = { ...calendarKindChecks.value }

    for (const uuid of calendarUuids) {
      nextChecks[uuid] = {
        ...(nextChecks[uuid] ?? defaultKindChecks()),
        [kind]: checked
      }
    }

    calendarKindChecks.value = nextChecks
  }

  return {
    calendarKindChecks,
    setAccountKindSync
  }
}
